import React from "react";
import Header from "./Components/Main/Header";
import Body from "./Components/Main/Body";
import "../public/styles.css";

const App = () => {
  return (
    <>
      <Header name="हाम्रो Flight Countdown" />
      <Body />
    </>
  );
};

export default App;
